import "@/App.css";
import { ReactLenis } from "lenis/react";
import { LangProvider } from "@/context/Lang";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import SocialProof from "@/components/site/SocialProof";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Manifesto from "@/components/site/Manifesto";
import Guarantee from "@/components/site/Guarantee";
import Testimonials from "@/components/site/Testimonials";
import MidCTA from "@/components/site/MidCTA";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";
import logo from "@/assets/logo.png";
import watermark from "@/assets/watermark.png";

function App() {
  return (
    <LangProvider>
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <div className="App relative overflow-hidden bg-white text-[#06142E] pb-16 md:pb-0" data-testid="app-root">
          <img
            src={watermark}
            alt=""
            aria-hidden="true"
            data-testid="logo-watermark"
            className="pointer-events-none select-none fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[min(72vw,860px)] max-h-[80vh] h-auto object-contain z-[40] opacity-[0.05]"
          />
          <Navbar />
          <main>
            <Hero />
            <Marquee />
            <SocialProof />
            <Services />
            <Gallery />
            <Manifesto />
            <Guarantee />
            <Testimonials />
            <MidCTA />
            <LeadForm />
          </main>
          <Footer />
          <FloatingActions />
          <Toaster position="top-center" richColors />
        </div>
      </ReactLenis>
    </LangProvider>
  );
}

export default App;
